import { AlertTriangle, Info, Lightbulb } from 'lucide-react';

export interface StoneGuideCalloutProps {
  type: 'info' | 'warning' | 'tip';
  text: string;
}

const VARIANTS = {
  info: {
    icon: Info,
    container: 'bg-stone-100 border-stone-400',
    iconColor: 'text-stone-600',
  },
  warning: {
    icon: AlertTriangle,
    container: 'bg-amber-50 border-amber-400',
    iconColor: 'text-amber-600',
  },
  tip: {
    icon: Lightbulb,
    container: 'bg-emerald-50 border-emerald-400',
    iconColor: 'text-emerald-600',
  },
} as const;

export function StoneGuideCallout({ type, text }: StoneGuideCalloutProps) {
  const variant = VARIANTS[type];
  const Icon = variant.icon;

  return (
    <aside
      className={`border-l-4 p-6 my-8 ${variant.container}`}
      role="note"
    >
      <div className="flex gap-4">
        <Icon className={`shrink-0 mt-0.5 ${variant.iconColor}`} size={20} strokeWidth={1.5} aria-hidden="true" />
        <p className="font-sans text-stone-700 font-light leading-relaxed text-sm md:text-base">
          {text}
        </p>
      </div>
    </aside>
  );
}

export default StoneGuideCallout;
